/* Playback for the image block's Cloudinary video.

   The markup ships no `autoplay` attribute, because a native autoplay cannot be
   called off once the browser has honoured it: `prefers-reduced-motion` is not
   something Liquid can read, and by the time a script runs the first frames have
   already replaced the poster. Starting playback here instead means a
   reduced-motion visitor keeps the poster — a still image of the same artwork —
   with nothing to undo. The cost is that playback needs JavaScript; without it the
   poster stands in, which is the intended fallback anyway.

   Two starts: `data-video-autoplay` goes as soon as the script runs,
   `data-play-in-view` waits for the block to reach the viewport. Either can carry
   `data-play-delay` in milliseconds. In-view videos play once and are unobserved —
   the feature exists for logos that animate and settle, and restarting one on every
   re-entry reads as a glitch. */
(function () {
  var BOUND = "data-block-video-bound";
  var SELECTOR = "video[data-video-autoplay], video[data-play-in-view]";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

  // An in-view block ships its poster as data-poster and renders bare, so the
  // animation is what brings the artwork in. A reduced-motion visitor never gets the
  // animation, so for them the still is promoted to a real poster — otherwise they
  // would be left looking at an empty box.
  function restorePoster(video) {
    var poster = video.getAttribute("data-poster");
    if (poster && !video.getAttribute("poster")) video.setAttribute("poster", poster);
  }

  function play(video) {
    // Checked at play time, not at bind time, so a visitor who turns the preference
    // on mid-visit is respected by everything that has not started yet.
    if (reduced.matches) {
      restorePoster(video);
      return;
    }
    var played = video.play();
    // Autoplay can still be refused — iOS Low Power Mode, a data-saver setting. The
    // poster stays up, which is what a paused video shows anyway.
    if (played && played.catch) played.catch(function () {});
  }

  function schedule(video) {
    var delay = parseInt(video.getAttribute("data-play-delay"), 10);
    if (delay > 0) window.setTimeout(function () { play(video); }, delay);
    else play(video);
  }

  var observer = null;
  if ("IntersectionObserver" in window) {
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          observer.unobserve(entries[i].target);
          schedule(entries[i].target);
        }
      },
      // A little inside the fold, so the animation starts as the block settles into
      // view rather than the instant its top edge clips the bottom of the screen.
      { rootMargin: "0px 0px -10% 0px" }
    );
  }

  function scan() {
    var videos = document.querySelectorAll(SELECTOR + ":not([" + BOUND + "])");
    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      video.setAttribute(BOUND, "");
      if (reduced.matches) restorePoster(video);
      if (video.hasAttribute("data-play-in-view") && observer) observer.observe(video);
      else schedule(video);
    }
  }

  scan();
  // Deferred modules run before `load` — assets/footer-marquee.js clones the track,
  // so a block inside a marquee produces copies this script has not seen yet.
  window.addEventListener("load", scan);
})();
